(function ($) {
	function loadmore() {
		var box = $('.timeline-box'),
			btn = $('.m-timeline .load-more a');

		btn.on('click', function (e) {
			e.preventDefault();

			if ($(this).hasClass('is-active')) {
				$(this).removeClass('is-active');
				$(this).find('span').text($(this).data('hide'));
				$(this).find('img').addClass('is-hidden');
				$(this)
					.parents('.load-more')
					.siblings('.timeline-box.is-hidden')
					.addClass('is-visible');
			} else {
				$(this).addClass('is-active');
				$(this).find('span').text($(this).data('show'));
				$(this).find('img').removeClass('is-hidden');
				$(this)
					.parents('.load-more')
					.siblings('.timeline-box.is-hidden')
					.removeClass('is-visible');
			}
		});

		box.hover(h1, h2);
		function h1() {
			// @ts-ignore-next
			var el = $(this);
			box.removeClass('is-active');
			el.addClass('is-active');
		}
		function h2() {
			// @ts-ignore-next
			var el = $(this);
			box.removeClass('is-active');
			el.addClass('is-active');
		}
	}

	loadmore();
})(jQuery);
